import { Service } from './service';

const url = {
  RESPOND: '/api/v1/vendor/call/respond',
};

export type CallResponseType = 'ACCEPTED' | 'DECLINED' | 'CANCELLED' | 'MISSED';

/**
 * Telling the other side how a call resolved.
 *
 * Lives in the chat window because that is the only part of the desktop app with a session: the
 * ring window is deliberately sandboxed with no network access, and the main process has no
 * credentials. The main process forwards the outcome here over IPC and this sends it on.
 */
export class CallService extends Service {
  respond(input: {
    roomCode: string;
    response: CallResponseType;
    notifyUserId: number;
  }) {
    return this.post(url.RESPOND, input, {}, { disableGlobalLoading: true });
  }
}
